import React from 'react';
import { usePersonalization } from '@/hooks/usePersonalization';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export const PersonalizationDebugger: React.FC = () => {
  const { profile, config, preferences, isLoading } = usePersonalization();

  if (!import.meta.env.DEV) {
    return null; // Only show in development
  }

  return (
    <Card className="mt-4 border-dashed">
      <CardHeader>
        <CardTitle className="text-sm">Personalization Debug Info</CardTitle>
        <CardDescription className="text-xs">Development only</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2 text-xs">
        <div>
          <strong>Loading:</strong> {isLoading ? 'Yes' : 'No'}
        </div>
        <div>
          <strong>Profile:</strong> {profile ? `${profile.first_name || 'No name'} (${profile.fitness_level || 'No level'})` : 'None'}
        </div>
        <div>
          <strong>Config:</strong> {config ? Object.keys(config).join(', ') : 'None'}
        </div>
        <div>
          <strong>Hidden Components:</strong> {config?.hiddenComponents?.length || 0}
        </div>
        <div>
          <strong>Prioritized Sections:</strong> {config?.prioritizedSections?.length || 0}
        </div>
        <div>
          <strong>Preferences:</strong> {preferences ? 'Available' : 'None'}
        </div>
      </CardContent>
    </Card>
  );
};